<main class="bg-white position-relative">
  <div class="payoutt_container">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 O-M-2">
          <div class="title_content">
            <h1 class="text-uppercase text-white open_sans font_68 bold_700 latest_new">Latest Update</h1>
            <p class="mt-lg-3 mt-xl-4 mt-2">We caught up professional skateboarder Jamie Foy on how<br/>
              he's spending time at home.</p>
            <div class="mt-lg-3 mt-xl-4">
              <a
                class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_16 mt-lg-2 mt-xl-3"
                routerLink="/categories-detail">Shop
                Now</a>
            </div>
          </div>
        </div>
        <div class="col-md-6 O-M-1">
          <img alt="" class="img-fluid float-right" src="/assets/images/news_shoes.png"/>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
  <!-- news-blog -->
  <div class="Blog-section">
    <div class="container">
      <div class="row blog_in_title">
        <h2 class="col-6 tile_blog">latest news</h2>
        <a class="col-6 see_all" href="#">see all <i aria-hidden="true" class="fa fa-angle-right"></i></a>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate" data-aos="fade-up">
          <div class="blog-main">
            <a href="#"><img alt="images" src="/assets/images/News_01.jpg"></a>
            <div class="blog-inner">
              <div class="date_month">
                <div class="date">22</div>
                <div class="month">feb</div>
              </div>
              <a class="blog-sub-title" routerLink="/news-detail"> Ever undertakes laborious physical</a>
              <p>Et harum quidem rerum facilis est et expedinctio. Nam libero tempore, cum soluta nobis est eligendi
                optio cumque nihil ipossimus</p>
              <a class="read_more" routerLink="/news-detail">Read More<i aria-hidden="true"
                                                                         class="fa fa-angle-double-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate" data-aos="fade-up">
          <div class="blog-main">
            <a href="#"><img alt="images" src="/assets/images/News_02.jpg"></a>
            <div class="blog-inner">
              <div class="date_month">
                <div class="date">22</div>
                <div class="month">feb</div>
              </div>
              <a class="blog-sub-title" routerLink="/news-detail"> Ever undertakes laborious physical</a>
              <p>Et harum quidem rerum facilis est et expedinctio. Nam libero tempore, cum soluta nobis est eligendi
                optio cumque nihil ipossimus</p>
              <a class="read_more" routerLink="/news-detail">Read More<i aria-hidden="true"
                                                                         class="fa fa-angle-double-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate" data-aos="fade-up">
          <div class="blog-main">
            <a href="#"><img alt="images" src="/assets/images/News_03.jpg"></a>
            <div class="blog-inner">
              <div class="date_month">
                <div class="date">22</div>
                <div class="month">feb</div>
              </div>
              <a class="blog-sub-title" routerLink="/news-detail"> Ever undertakes laborious physical</a>
              <p>Et harum quidem rerum facilis est et expedinctio. Nam libero tempore, cum soluta nobis est eligendi
                optio cumque nihil ipossimus</p>
              <a class="read_more" routerLink="/news-detail">Read More<i aria-hidden="true"
                                                                         class="fa fa-angle-double-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate" data-aos="fade-up">
          <div class="blog-main">
            <a href="#"><img alt="images" src="/assets/images/News_04.jpg"></a>
            <div class="blog-inner">
              <div class="date_month">
                <div class="date">22</div>
                <div class="month">feb</div>
              </div>
              <a class="blog-sub-title" routerLink="/news-detail"> Ever undertakes laborious physical</a>
              <p>Et harum quidem rerum facilis est et expedinctio. Nam libero tempore, cum soluta nobis est eligendi
                optio cumque nihil ipossimus</p>
              <a class="read_more" routerLink="/news-detail">Read More<i aria-hidden="true"
                                                                         class="fa fa-angle-double-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate" data-aos="fade-up">
          <div class="blog-main">
            <a href="#"><img alt="images" src="/assets/images/News_05.jpg"></a>
            <div class="blog-inner">
              <div class="date_month">
                <div class="date">22</div>
                <div class="month">feb</div>
              </div>
              <a class="blog-sub-title" routerLink="/news-detail"> Ever undertakes laborious physical</a>
              <p>Et harum quidem rerum facilis est et expedinctio. Nam libero tempore, cum soluta nobis est eligendi
                optio cumque nihil ipossimus</p>
              <a class="read_more" routerLink="/news-detail">Read More<i aria-hidden="true"
                                                                         class="fa fa-angle-double-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-6 mb-lg-0 aos-init aos-animate" data-aos="fade-up">
          <div class="blog-main">
            <a href="#"><img alt="images" src="/assets/images/News_06.jpg"></a>
            <div class="blog-inner">
              <div class="date_month">
                <div class="date">22</div>
                <div class="month">feb</div>
              </div>
              <a class="blog-sub-title" routerLink="/news-detail"> Ever undertakes laborious physical</a>
              <p>Et harum quidem rerum facilis est et expedinctio. Nam libero tempore, cum soluta nobis est eligendi
                optio cumque nihil ipossimus</p>
              <a class="read_more" routerLink="/news-detail">Read More<i aria-hidden="true"
                                                                         class="fa fa-angle-double-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
